import ResetPasswordInput from "./resetInput.container";

export default ResetPasswordInput;
